import { FunctionComponent } from "react"
import First from "./first-podium.svg"
import Second from "./second-podium.svg"
import Third from "./third-podium.svg"

interface PodiumBadgeProps {
    place: number | undefined
}

const badgeMap = { 1: First, 2: Second, 3: Third } as Record<number, FunctionComponent>

const PodiumBadge: FunctionComponent<PodiumBadgeProps> = ({ place }) => {
    if (!place || place > 3) return null

    const Badge = badgeMap[place]

    return (
        <div>
            <Badge />
        </div>
    )
}

export { PodiumBadge }
